import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNorthernCyprus = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_974)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.90339 4.17389C2.48231 4.66294 2.10004 5.1862 1.76123 5.73909H22.2387C21.8999 5.1862 21.5176 4.66289 21.0965 4.17389H2.90339Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.90339 19.8261H21.0966C21.5176 19.3371 21.8999 18.8138 22.2387 18.2609H1.76128C2.10004 18.8138 2.48231 19.3371 2.90339 19.8261Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4644 9.80559L11.4489 11.1624L13.0435 10.6454L12.0574 12.001L13.0418 13.3577L11.4479 12.8387L10.4617 14.1944L10.4627 12.5181L8.86874 11.9991L10.4633 11.482L10.4644 9.80559Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.77726 15.3913C5.90432 15.3913 4.38595 13.8729 4.38595 12C4.38595 10.1271 5.90432 8.60869 7.77726 8.60869C8.36123 8.60869 8.91074 8.75635 9.39046 9.01632C8.63788 8.28033 7.60865 7.82607 6.47292 7.82607C4.1677 7.82607 2.29903 9.69478 2.29903 12C2.29903 14.3051 4.16774 16.1738 6.47292 16.1738C7.60865 16.1738 8.63788 15.7196 9.39046 14.9836C8.91074 15.2437 8.36127 15.3913 7.77726 15.3913Z",
				fill: "#D80027"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_974",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgNorthernCyprus;
